import * as React from "react"
import { Box, Typography } from "@mui/material"

import { LabelCountry } from "@components"
import { boxListRetailers } from "./styles"


export default function ListRetailers({ retailers }) {
    return <Box sx={ boxListRetailers }>
		{ retailers.map((item, idx) => <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
                <Typography component="div" variant="body2">
                    <LabelCountry country={item.country} label={item.name} ellipsis={true} />
                </Typography>
            </Box>
        )}
	</Box>
}